import { Component, OnInit } from '@angular/core';
import { Navigation, Router } from '@angular/router';
import { User } from 'src/app/model/user';
import { environment } from 'src/environments/environment';
import { OnboardingFormType } from '../../onboarding/models/onboarding-form-type.enum';
import { Globals } from 'src/app/Utils/globals';
import { OnboardingService } from '../../onboarding/onboarding.service';

@Component({
  selector: 'app-ready-to-start',
  templateUrl: './ready-to-start.component.html',
  styleUrls: ['./ready-to-start.component.scss'],
})
export class ReadyToStartComponent implements OnInit {
  user: User;
  navigation: Navigation;
  constructor(
    private router: Router,
    private readonly service: OnboardingService,
    private readonly globals: Globals,
  ) {
    this.navigation = this.router.getCurrentNavigation();
  }
  newAsset: boolean = true;
  createdAsset: OnboardingFormType;
  onboardingFormType = OnboardingFormType;
  beingOnboardedTitle: string;

  ngOnInit(): void {
    this.user = this.service.getUserAndNavigate(this.navigation, this.router);
    this.handleNewAsset();
  }

  handleNewAsset(): void {
    const createdAssetItem = sessionStorage.getItem('createdAsset');
    if (createdAssetItem) {
      this.newAsset = false;
      this.createdAsset = JSON.parse(createdAssetItem)
        ? OnboardingFormType.Application
        : OnboardingFormType.Library;
      sessionStorage.removeItem('createdAsset');
      this.beingOnboardedTitle = JSON.parse(createdAssetItem)
        ? 'component.readytostart.beingonboarded'
        : 'component.readytostart.beingonboarded-library';
    }
  }

  takeATour(): void {
    (window.location.href = environment.urls.apiBaseUrl + +'login?op=tour'),
      '_blank';
  }

  navigateToAppOnboarding(): void {
    sessionStorage.setItem(
      'asset',
      JSON.stringify(OnboardingFormType.Application),
    );
    this.router.navigate(['/onboarding']);
  }

  navigateToLibraryOnboarding(): void {
    sessionStorage.setItem('asset', JSON.stringify(OnboardingFormType.Library));
    this.router.navigate(['/onboarding']);
  }

  backToDashboard() {
    this.router.navigate(['/dashboard']);
  }

  isCreateLibraryEnabled() {
    if (this.user?.applications?.length === 0) {
      return true;
    }
    return this.service.isPortalActionVisibleForAnyApp(
      this.user.applications,
      this.globals.ACC_CREATE_LIBRARY,
      this.globals.ONBOARDING,
    );
  }
}
